// CUSTOM: personalised-cart-integration.js
//= require personalised-config.js
//= require personalised-storage-manager.js
//= require personalised-bundle-state.js

(function() {
  // Ensure namespace exists
  window.personalised = window.personalised || {};
  
  // Module implementation
  const cartIntegration = {
    initialized: false,
    
    /**
     * Initializes the cart integration by setting up event listeners
     * to detect when bundle items are removed from the cart
     */
    init: function() {
      if (this.initialized) return;
      
      // Subscribe to Shopify cart update events via the theme's pubsub system
      if (window.FoxTheme && window.FoxTheme.pubsub) {
        window.FoxTheme.pubsub.subscribe(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          this.handleCartUpdate.bind(this)
        );
        
        console.debug('[CartIntegration] Subscribed to cart update events');
      } else {
        console.warn('[CartIntegration] FoxTheme pubsub not available, cart integration disabled');
      }
      
      this.initialized = true;
    },
    
    /**
     * Handles cart update events from the theme's pubsub system
     * Detects when bundle items are removed and clears bundle state if needed
     * @param {Object} event - The cart update event
     */
    handleCartUpdate: function(event) {
      if (!event || !event.cart) {
        console.warn('[CartIntegration] Invalid cart update event:', event);
        return;
      }
      
      try {
        // Check if we have bundle state in localStorage
        const bundleState = window.personalised.storageManager.getBundleState();
        if (!bundleState) return; // No bundle state to clear
        
        // Get the bundle parent property key from config
        const BUNDLE_PARENT_PROPERTY = window.personalised.config.bundle.RECHARGE_KEYS.BUNDLE_PARENT_PROPERTY;
        const BUNDLE_PARENT_KEY = window.personalised.config.bundle.BUNDLE_PARENT_PROPERTY_KEY;
        
        // Check if any bundle items exist in the cart
        const bundleItemsInCart = event.cart.items.some(item => 
          item.properties && 
          item.properties[BUNDLE_PARENT_PROPERTY] === BUNDLE_PARENT_KEY
        );
        
        // If no bundle items in cart but we have bundle state, clear it
        if (!bundleItemsInCart && bundleState) {
          console.debug('[CartIntegration] Bundle removed from cart, clearing bundle state');
          
          // Clear bundle state from localStorage
          window.personalised.storageManager.clearBundleState();
          
          // Teardown bundle state completely if available
          if (window.personalised.bundle && typeof window.personalised.bundle.teardown === 'function') {
            window.personalised.bundle.teardown();
          }
          
          // Emit event for UI components to update
          if (window.personalised.eventBus) {
            window.personalised.eventBus.emit('bundleRemovedFromCart', {
              message: 'Bundle removed from cart'
            });
          }
        }
      } catch (err) {
        console.error('[CartIntegration] Error handling cart update:', err);
      }
    }
  };
  
  // Initialize on DOMContentLoaded if we're on a cart page
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a cart page by looking for cart elements
    const isCartPage = document.querySelector('cart-items') !== null;
    
    // Initialize immediately if we're on a cart page
    if (isCartPage) {
      cartIntegration.init();
    } else {
      // Otherwise, initialize when Shopify pubsub is available
      const waitForPubSub = setInterval(function() {
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          clearInterval(waitForPubSub);
          cartIntegration.init();
        }
      }, 100);
      
      // Don't wait forever - stop checking after 5 seconds
      setTimeout(function() {
        clearInterval(waitForPubSub);
      }, 5000);
    }
  });
  
  // Expose the module
  window.personalised.cartIntegration = cartIntegration;
})();
